<template>
  <span>
    <a-button :loading="loading" icon="unordered-list" @click="visibleModal = true">
      Uncompleted Task ({{ taskCount }})
    </a-button>

    <a-modal
      title="Uncompleted Task"
      :visible="visibleModal"
      :destroy-on-close="true"
      width="900px"
      @cancel="visibleModal = false"
    >
      <profile-critical-task v-if="visibleModal" @updated="loadCount" />

      <template slot="footer">
        <div class="flex justify-content-between">
          <a-button @click="visibleModal = false">Close</a-button>
        </div>
      </template>
    </a-modal>
  </span>
</template>

<script>
import { Button, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import ProfileViewCriticalTask from './profile-view-critical-task.vue'

const { mapActions: alertActions } = createNamespacedHelpers('alerts')
const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  name: 'ProfileUncompletedTaskAction',
  components: {
    'a-button': Button,
    'a-modal': Modal,
    'profile-critical-task': ProfileViewCriticalTask
  },
  data() {
    return {
      loading: false,
      taskCount: 0,
      visibleModal: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  watch: {
    'associate.id': {
      handler(newVal) {
        if (newVal) {
          this.loadCount()
        }
      },
      immediate: true
    }
  },
  methods: {
    ...alertActions(['getAssociateUncompletedTasks']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async loadCount() {
      if (!this.associate?.id) {
        this.taskCount = 0
        return
      }

      this.loading = true

      try {
        const data = await this.getAssociateUncompletedTasks({
          associate_id: this.associate.id
        })

        this.taskCount = data?.tasks?.length ?? 0
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
